import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("admin_token", token);
  } else {
    localStorage.removeItem("admin_token");
  }
}

export function getAdminToken() {
  return localStorage.getItem("admin_token");
}

api.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers["X-Admin-Password"] = token;
  }
  return config;
});
